import React from 'react';
import {HiLocationMarker} from 'react-icons/hi';
import {IoLogoWhatsapp} from 'react-icons/io';
import {GrMail} from 'react-icons/gr';
import {FaTelegramPlane} from 'react-icons/fa';
import { BsGithub, BsLinkedin} from 'react-icons/bs';

import "./footer.css"
import "./footerXLarge.css" 

const Footer = () => {
  return (
    <div className='footer-wrapper'>
        <footer className='footer'>
            <div className='location'>
                  <a href="https://goo.gl/maps/NMpYP1brKHX5bYyC8" rel="noreferrer" target="_blank" className="logo__link">
                    <div className='logo'>
                    <HiLocationMarker className='location-logo' />
                    </div>
                    <div className='info'>
                      <h4>LOCATION</h4>
                      <p>Taipei, Taiwan</p>
                    </div>
                  </a>
                </div>

                <div className='phone'>
                  <a href="https://wa.me/886987032439" rel="noreferrer" target="_blank" className="logo__link">
                    <div className='logo'>
                      <IoLogoWhatsapp className='phone-logo' />
                    </div>
                    <div className='info'>
                      <h4>WHATSAPP</h4>
                      <p>(+886) 987 032 439</p>
                    </div>
                  </a>
                </div>

                <div className='phone'>
                  <a href="https://t.me/luca_frontend" rel="noreferrer" target="_blank" className="logo__link">
                    <div className='logo'>
                      <FaTelegramPlane className='phone-logo' />
                    </div>
                    <div className='info'>
                      <h4>TELEGRAM</h4>
                      <p>@luca_frontend</p>
                    </div>
                  </a>
                </div>

                <div className='email'>
                  <a href="mailto:hochedezluca@proton.me?subject=Let's Connect" rel="noreferrer" target="_blank" className="logo__link">
                    <div className='logo'>
                      <GrMail className='mail-logo' />
                    </div>
                    <div className='info'>
                      <h4>EMAIL</h4>
                      <p>hochedezluca@proton.me</p>
                    </div>
                  </a>
                </div>

                <div className='github'>
                  <a href="https://github.com/Akaid0"  target="_blank" rel="noreferrer" className="logo__link">
                    <div className='logo'>
                      <BsGithub className='github-logo' />
                    </div>
                    <div className='info'>
                      <h4>GITHUB</h4>
                      <p>Akaid0</p>
                    </div>
                  </a>
                </div>

                <div className='linkedin'>
                  <a href="https://www.linkedin.com/in/lucawebdev/"  target="_blank" rel="noreferrer" className="logo__link">
                    <div className='logo'>
                      <BsLinkedin className='linkedin-logo' />
                    </div>
                    <div className='info'>
                      <h4>LINKEDIN</h4>
                      <p>Luca</p>
                    </div>
                  </a>
                </div>
            </footer>
          </div>
  )
}

export default Footer